import {useSelector} from "react-redux";
import {selectUserState} from "../store/selectors";

export const usePermissions = () => {
    const {userData: user} = useSelector(selectUserState);

    return {
        isSuperUser: user?.is_superuser || false,
        isOEM: user?.is_oem || false,
        isAccountManager: user?.is_accounts_management || false,
        isManager: user?.is_manager || false,
        isVisualDashboard: user?.visual_dashboard_enabled || false,
        isExplorerEnabled: user?.explorer_enabled || false,
        isEngineer: user?.is_engineer || false,
        hasAccessToEdit: user?.is_manager || user?.is_accounts_management || user?.is_oem || user?.is_superuser || false,
        hasAccessToSensorImages: user?.is_manager || user?.is_accounts_management || user?.is_oem || user?.is_superuser || user?.is_engineer || false,
    };
};
